export enum MediaSizeEnum {
  THUMBNAIL = 'thumbnail',
  MEDIUM = 'medium',
  MEDIUM_LARGE = 'medium_large',
  FULL = 'full',
  LARGE = 'large',
  BIG = '1536x1536',
  BIGGEST = '2048x2048',
}

export enum CustomPostTypeEnum {
  BLOG = 'blog',
  GUIDE = 'guide',
  GUIDE_LINK = 'guidelink',
  NATIVE = 'native',
  PAGES = 'pages',
  USERS = 'users',
  LANDING_PAGE_CAREPROVIDER = 'landingpage',
  LANDING_PAGE_CAMPAIGN = 'landingpagecampaign',
  LANDING_PAGE_CONTACT = 'landingpagecontact',
  LANDING_PAGE_NEWS = 'landingpagenewsbox',
  SERVICE_TYPE_PAGE = 'careservicepage',
  SYMPTOM_PAGE = 'symptompage',
}

export enum CustomPostTypePathKeyEnum {
  BLOG = 'wp-json/wp/v2/blog',
  GUIDE = 'wp-json/wp/v2/guide',
  GUIDE_LINK = 'wp-json/wp/v2/guidelink',
  NATIVE = 'wp-json/wp/v2/native',
  PAGES = 'wp-json/wp/v2/pages',
  USERS = 'wp-json/wp/v2/users',
  LANDING_PAGE_CAREPROVIDER = 'wp-json/wp/v2/landingpage',
  LANDING_PAGE_CAMPAIGN = 'wp-json/wp/v2/landingpagecampaign',
  LANDING_PAGE_CONTACT = 'wp-json/wp/v2/landingpagecontact',
  LANDING_PAGE_NEWS = 'wp-json/wp/v2/landingpagenewsbox',
  SERVICE_TYPE_PAGE = 'wp-json/wp/v2/careservicepage',
  SYMPTOM_PAGE = 'wp-json/wp/v2/symptompage',
}

export enum CustomPostTypeObjectNameEnum {
  BLOG = 'blog',
  GUIDE = 'guide',
  GUIDE_LINK = 'guidelink',
  NATIVE = 'native',
  PAGE = 'page',
  CUSTOM = 'custom',
  LANDING_PAGE = 'landingpage',
  LANDING_PAGE_CONTACT = 'landingpagecontact',
  LANDING_PAGE_NEWS = 'landingpagenewsbox',
  SERVICE_TYPE_PAGE = 'careservicepage',
  SYMPTOM_PAGE = 'symptompage',
}

export enum TaxonomyEnum {
  BLOG_TAG = 'blogtag',
  GUIDE_TAG = 'guidetag',
  CPRU_TYPE = 'care_provider_unit_type',
  SERVICE_TYPE = 'care_service_type',
  PLACE = 'places',
}

export enum TaxonomyCombinedEnum {
  CPRU_TYPE = 'careProviderUnitTypes',
  SERVICE_TYPE = 'careServiceTypes',
  PLACE = 'places',
}

export enum CommentStatusEnum {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum PageTemplateEnum {
  DEFAULT = '',
  HOME = 'templates/home.php',
  FOR_CAREPROVIDERS = 'templates/for-careproviders.php',
}

export enum NativePuffFlagEnum {
  HOME = 'showHomePuff',
  SIDEBAR = 'showSidebarPuff',
}

export enum GuidePuffsPlacementEnum {
  BELOW = 'below',
  ABOVE = 'above',
}
